<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>
  <p-toast position="bottom-right" key="br"></p-toast>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>
          {{ 'Receipts_Title' | translateWF: 'Receipts' }}
        </h1>
        <div class="page__title_buttons">
          @if (canEdit()) {
            <p-speeddial [model]="newReceiptActions" direction="left" [transitionDelay]="80">
              <ng-template #button let-toggleCallback="toggleCallback">
                <p-button (click)="toggleCallback($event)" [label]="'New' | translateWF: 'New'" icon="pi pi-plus" iconPos="left"></p-button>
              </ng-template>
              <ng-template #item let-item let-toggleCallback="toggleCallback">
                <p-button severity="secondary" (click)="toggleCallback($event, item)" [label]="item.label | translateWF: item.label"></p-button>
              </ng-template>
            </p-speeddial>
          }
        </div>
      </div>
    </div>

    <div class="cs-page-list-grid">
      @if (filterConfig() && showFilters()) {
        <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
      }

      <p-panel [header]="'Receipts_Title' | translateWF: 'Receipts'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="listReceipts()" dataKey="id" [lazy]="true" [sortField]="sortField()" [sortOrder]="sortOrder()" selectionMode="single" (onSort)="onSort($event)">
            <ng-template pTemplate="header">
              <tr class="cs-datatable-header-dark">
                <th pSortableColumn="number">
                  {{ 'Receipts_Number' | translateWF: 'Receipt Number' }}
                  <p-sortIcon field="number"></p-sortIcon>
                </th>
                <th>{{ 'Receipts_Provider' | translateWF: 'Provider' }}</th>
                <th>{{ 'Receipts_Type' | translateWF: 'Type' }}</th>
                <th>{{ 'Receipts_Provider_Invoice_Number' | translateWF: 'Provider Invoice Number' }}</th>
                <th>{{ 'Receipts_Status' | translateWF: 'Status' }}</th>
                <th class="text-right">{{ 'Receipts_Total' | translateWF: 'Total' }}</th>
                <th>{{ 'Receipts_Issued_Date' | translateWF: 'Issued Date' }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData>
              @let receipt = getRowData(rowData);
              <tr class="cursor-pointer" (click)="redirectToDetails(receipt.id!)">
                <td>
                  <a>{{ receipt?.number }}</a>
                </td>
                <td>{{ receipt?.provider?.name }}</td>
                <td>{{ typeLabel(receipt.type) | translateWF: typeLabel(receipt.type) }}</td>
                <td>{{ receipt?.providerInvoiceNumber }}</td>
                <td>{{ statusLabel(receipt.status) }}</td>
                <td class="text-right">{{ receipt?.totalAmount | number: '1.2-2' }}</td>
                <td>{{ receipt?.issuedDate | date: 'yyyy-MM-dd' }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="7">
                  {{ 'Receipts_No_Receipts_Found' | translateWF: 'No receipts found' }}
                </td>
              </tr>
            </ng-template>
          </p-table>
          <p-paginator
            [rows]="pageSize()"
            [totalRecords]="totalRecords()"
            [first]="(currentPage() - 1) * pageSize()"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[15, 25, 50, 100]"
            dropdownAppendTo="body"
            class="mt-4"
          />
        </p-card>
      </p-panel>
    </div>
  </div>
</main>
